export const apiUrl = 'http://20.115.98.230';
// export const apiUrl = 'http://localhost:80'; //DEV
// export const apiUrl = 'http://192.168.115.179:21000'; // HOMOLOG
